module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : [(_vm.error) ? [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))])] : _vm._e(), (!_vm.error) ? [_c('b-tabs', {
    ref: "tabs",
    staticClass: "top-tab-navigation",
    attrs: {
      "lazy": true
    },
    on: {
      "input": _vm.onTabChanged
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, _vm._l((_vm.tabs), function(tab, key) {
    return _c('b-tab', {
      key: key,
      attrs: {
        "title": _vm.$t(tab.name),
        "buttonId": "proposal-tab-" + key
      }
    }, [_c('div', {
      staticClass: "container table-container"
    }, [_c('b-form-input', {
      staticClass: "table-search col-md-4 push-md-8 col-sm-12",
      attrs: {
        "placeholder": _vm.$t("pos.proposals.search")
      },
      model: {
        value: (_vm.filter_string_ui),
        callback: function($$v) {
          _vm.filter_string_ui = $$v
        },
        expression: "filter_string_ui"
      }
    }), _c('b-table', {
      ref: "table",
      refInFor: true,
      attrs: {
        "items": _vm.provideItems,
        "items_key": "id",
        "fields": _vm.options[key].fields,
        "currentPage": 1,
        "perPage": _vm.loadSize,
        "responsive": false,
        "hover": "hover",
        "sortBy": "created",
        "sortDesc": false,
        "filter": _vm.filter_string
      },
      on: {
        "row-clicked": _vm.openDraft
      },
      scopedSlots: _vm._u([{
        key: "company",
        fn: function(item) {
          return [_c('div', {
            staticClass: "item-company"
          }, [_vm._v(_vm._s(_vm.get(item, 'item.customer.name')))])]
        }
      }, {
        key: "name",
        fn: function(item) {
          return [_c('div', {
            staticClass: "item-name"
          }, [_vm._v(_vm._s(_vm.get(item, 'item.name')))])]
        }
      }, {
        key: "target",
        fn: function(item) {
          return [_vm._v(_vm._s(_vm.$t('draft_field.format.target', {
            users: _vm.get(item, 'item.potentialReach', 0)
          })))]
        }
      }, {
        key: "goal",
        fn: function(item) {
          return [_vm._v(_vm._s(_vm.$t(("terms.campaign-goal." + (_vm.get(item, 'item.goal_type', 'reach_frequency'))))))]
        }
      }, {
        key: "created",
        fn: function(item) {
          return [_c('div', {
            staticClass: "item-created"
          }, [_vm._v(_vm._s(_vm.$t('draft_field.format.created', {
            created: item.value
          })))])]
        }
      }, {
        key: "locations",
        fn: function(item) {
          return _vm._l((_vm.get(item, "item.target.locations", [])), function(loc) {
            return _c('div', {
              staticClass: "item-locations"
            }, [_c('span', [_vm._v(_vm._s(_vm.$t('draft_field.format.location', {
              type: loc.type,
              name: loc.name
            })))])])
          })
        }
      }, {
        key: "nextStep",
        fn: function(item) {
          return [_c('div', {
            staticClass: "item-step"
          }, [_vm._v(_vm._s(item.value ? _vm.$t('draft_field.format.step', {
            step: item.value.route
          }) : ''))])]
        }
      }, {
        key: "status",
        fn: function(item) {
          return [_c('div', {
            staticClass: "item-status"
          }, [_vm._v(_vm._s(_vm.$t(("terms.campaign_status." + (_vm.get(item, 'item.status.code'))))))])]
        }
      }, {
        key: "customer_remote_id",
        fn: function(item) {
          return [_c('div', {
            staticClass: "item-customer_remote_id"
          }, [_vm._v(_vm._s(_vm.get(item, 'item.customer.remote_id', '')))])]
        }
      }])
    }), (_vm.canLoadMore && !_vm.fetchingDrafts) ? _c('div', {
      staticClass: "justify-content-center row"
    }, [_c('b-btn', {
      attrs: {
        "type": "button",
        "value": "show_more",
        "variant": "success"
      },
      on: {
        "click": function($event) {
          _vm.loadMore()
        }
      }
    }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm.$t('pos.proposals.show-more'))))])], 1) : _vm._e(), (_vm.fetchingDrafts) ? _c('div', {
      staticClass: "justify-content-center row"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('terms.misc.loading')))])]) : _vm._e(), (!_vm.fetchingDrafts) ? _c('p', {
      staticClass: "text-proposal"
    }, [_c('i', [_vm._v(_vm._s(_vm.$t('pos.proposals.count', {
      count: _vm.totalCount
    })))])]) : _vm._e()], 1)])
  }))] : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aea59d8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proposals-remote/ProposalsRemote.vue
// module id = 933
// module chunks = 1